import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dot-main-booker-skeleton',
  templateUrl: './main-booker-skeleton.component.html',
  styleUrls: ['./main-booker-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainBookerSkeletonComponent {}
